import { ActionTree, MutationTree, GetterTree } from 'vuex'
import { AuthStore, ParsedJwt, State } from '@/types'

var state = {
  rawJwt: null,
}

const mutations: MutationTree<AuthStore> = {
  setJwt(state: AuthStore, jwt: string | null) {
    state.rawJwt = jwt
  },
}

const actions: ActionTree<AuthStore, State> = {

}

const getters: GetterTree<AuthStore, State> = {
  parsedJwt(state: AuthStore): ParsedJwt {
    if (state.rawJwt) {
      var base64Url = state.rawJwt.split('.')[1]
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      return JSON.parse(window.atob(base64))
    }
    else {
      return {}
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
